<template>
  <v-btn
    fab
    dark
    x-small
    color="primary"
    :title="$i18n.t(title)"
    v-on="$listeners"
  >
    <v-icon class="title">{{icon}}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'base-map-button',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>